export var EnrichmentSource;
(function (EnrichmentSource) {
    EnrichmentSource["APOLLO"] = "apollo";
    EnrichmentSource["WEB_SCRAPE"] = "web_scrape";
    EnrichmentSource["USER_PROVIDED"] = "user_provided";
    EnrichmentSource["CRM"] = "crm";
})(EnrichmentSource || (EnrichmentSource = {}));
export var EnrichmentStatus;
(function (EnrichmentStatus) {
    EnrichmentStatus["PENDING"] = "pending";
    EnrichmentStatus["ENRICHING"] = "enriching";
    EnrichmentStatus["ENRICHED"] = "enriched";
    EnrichmentStatus["PARTIAL"] = "partial";
    EnrichmentStatus["FAILED"] = "failed";
})(EnrichmentStatus || (EnrichmentStatus = {}));
//# sourceMappingURL=prospect.js.map